// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Lh9y","row":"styles_row__2fMrS"};